import { UsersSideMenuWebComponent } from './component/UsersSideMenuWebComponent';

export { UsersSideMenuWebComponent };
